import { DiscountValueType, ProductType, DiscountActionTargetTypeEnum, DiscountBandType, DiscountBandTypeEnum } from "app/shared/model";
import { ProductFilterType, ProductFilter, SelectionMap } from "app/shared/model/ProductFilter";
import { Fee } from "app/shared/model/Fee";
import { DeleteDiscountAction } from "app/pages/DiscountEditor/actionTypes";

export enum DiscountActionFormStatus {
    ReadOnly = 'ReadOnly',
    AddNewDiscountAction = 'AddNewDiscountAction',
    AddOrEditDiscountBands = 'AddOrEditDiscountBands', 
    DeleteConfirmation = 'DeleteConfirmation'     
}

export interface DiscountActionState {
    form: DiscountActionForm
    actions: SavedDiscountActionMap,
    fees: Fee[]
}

export interface ApplicableProductsDiscountTarget {
    type: DiscountActionTargetTypeEnum.ApplicableProducts,
}

export interface OtherProductsDiscountTarget {
    type: DiscountActionTargetTypeEnum.OtherProducts,
    products: ProductFilter
}

export interface FeesDiscountTarget {
    type: DiscountActionTargetTypeEnum.Fees,
    fees: SelectionMap
}

export type DiscountTarget =
    ApplicableProductsDiscountTarget
    | OtherProductsDiscountTarget
    | FeesDiscountTarget

export interface EditableDiscountBand {
    from: string
    to: string
    value: string
    isValid: boolean
    fromMessage?: string
    toMessage?: string
    valueMessage?: string
}

export interface EditableBandedDiscount {
    id: string
    isNew: boolean
    bandType: DiscountBandTypeEnum
    bands: EditableDiscountBand[]
    showValidation: boolean
    discountValueType: DiscountValueType
    target: DiscountTarget
    currencyCode?: string
}

export interface EmptyDiscountActionForm {
    status: DiscountActionFormStatus.ReadOnly|DiscountActionFormStatus.AddNewDiscountAction
}

export interface AddOrEditDiscountActionForm {
    status: DiscountActionFormStatus.AddOrEditDiscountBands
    discount: EditableBandedDiscount
}

export interface DeleteDiscountActionConfirmationForm {
    status: DiscountActionFormStatus.DeleteConfirmation
    id: string
    name: string
}

export type DiscountActionForm = 
    EmptyDiscountActionForm 
    | AddOrEditDiscountActionForm
    | DeleteDiscountActionConfirmationForm;

export type SavedDiscountAction = {
    id: string, 
    isNew: boolean
    longName: string
    valueType: DiscountValueType
    bandType: DiscountBandTypeEnum
    bands: SavedDiscountBand[]
    target: DiscountTarget
    errorMessage?: string
    currencyCode?: string
};

export type SavedDiscountBand = {
    minUnits: number
    maxUnits?: number
    value: number
}

export type SavedDiscountActionMap = {
    nextId: number,
    items: { [id: string]: SavedDiscountAction }
}